/**
 * The lengths the two duration lists offer.
 *
 * Constants rather than a fetch, unlike the exercise types beside them: there
 * is no catalog behind a number of hours, and the backend takes the duration
 * as two plain figures — see `ExercisePlanExerciseResponse`.
 */

/** 0 to 6 hours. Past that, a day's exercise is not what is being written down. */
export const HOUR_OPTIONS: number[] = [0, 1, 2, 3, 4, 5, 6];

/** Quarter hours, which is as fine as anyone times a session they prescribe. */
export const MINUTE_OPTIONS: number[] = [0, 15, 30, 45];
